// extracted by mini-css-extract-plugin
export default {"backDivider":"GXzqML"};